import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    ref: "outer-container",
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-virtual-device-packet-viewer', {
    ref: "packet-viewer",
    attrs: {
      "height": _vm.height,
      "bridgeManifest": _vm.bridgeManifest,
      "valuePath": `value.${_vm.get(_vm.bridgeManifest, 'virtualDevice.deviceTypes.packetParser.valueMapping.payload')}`,
      "packetHistory": _vm.packetHistory,
      "dataIsLoading": _vm.dataIsLoading,
      "loadingError": _vm.loadingError,
      "loadingDone": _vm.loadingDone,
      "isLiveViewer": _vm.isLiveViewer,
      "showLoadMore": Boolean(_vm.packetHistory.length && _vm.packetHistory.length <= _vm.serverItemsLength)
    },
    on: {
      "click": e => _vm.clickRowHandler(e),
      "loadData": _vm.loadData
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };